import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './features.css';
import TheLayout from '../../layout/TheLayout';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import FirstView from '../../asset/firstview.png';
import BackgroundTop from '../../asset/Features/backgroundtop.png';
import FeaturesTop from '../../asset/Features/featurestop.png';
import Features10 from '../../asset/Features/features10.png';
import Features11 from '../../asset/Features/features11.png';
import Features20 from '../../asset/Features/features20.png';
import Features21 from '../../asset/Features/features21.png';
import Features22 from '../../asset/Features/features22.png';
import Features30 from '../../asset/Features/features30.png';
import Features31 from '../../asset/Features/features31.png';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Features = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>商品特長｜株式会社TERRA</title>
      </Helmet>
      <div className="features">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          商品特長
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>商品特長</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-0">
          <div className="row m-0">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9 p-0">
              <div
                className="m-auto p-0 p-lg-5"
              >
                <div
                  className="featuresTop d-block d-md-flex align-items-center justify-content-around text-white m-auto"
                  style={{
                    backgroundImage: `url(${BackgroundTop})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    fontSize: '1.8rem',
                    color: 'white',
                    height: '350px',
                    maxWidth: '100%',
                  }}
                >
                  天然成分にこだわった
                  <br />
                  「森」と「イオン」の
                  <br />
                  徹底除菌＆消臭
                  <img src={FeaturesTop} alt="商品特長" />
                </div>
                <div className="features_title">
                  TERRA  FORESTAの商品
                </div>
                <div className="row my-4 mr-0">
                  <div className="col-12 col-lg-6 features_text">
                    <p>
                      皆さまの健康のために,お部屋の空気をすこやかに。
                      <br />
                      TERRAは「森」と「イオン」の融合した天然の力で空気中のウイルス・菌を徹底除去＆抑制！
                    </p>
                  </div>
                  <div className="col-12 col-lg-6 bg-white p-0">
                    <img src={Features10} style={{ width: '100%' }} alt="商品特長" />
                  </div>
                </div>
                <div className="row my-4 mr-0">
                  <div className="col-12 col-lg-6 order-2 order-lg-1 p-0">
                    <img src={Features11} style={{ width: '100%' }} alt="商品特長" />
                  </div>
                  <div className="col-12 col-lg-6 order-1 order-lg-2 features_text">
                    <p>
                      売れ筋商品の「タワー型噴霧器」はお部屋の
                      <mark>広さ約40畳（約65平米）まで対応が可能</mark>
                      です。
                      <br />
                      広い事務所にも対応致します。
                    </p>
                  </div>
                </div>
                <div className="features_title">
                  独自の天然成分技術
                </div>
                <div className="row my-4 mr-0">
                  <div className="col-12 col-lg-6 features_text">
                    <p>
                      TERRA FORESTAはアルコール等の化学物質を一切加えずにつくられた天然植物の抽出除菌液です。
                      <br />
                      <mark>
                        除菌効果をもつイオン水に青森ヒバ、ヒノキ、ユーカリから抽出した精油などを成分とし、
                      </mark>
                      製造過程で化学薬品を一切使用していない、体に安全・無害なノンアルコール除菌消臭液です。
                    </p>
                  </div>
                  <div className="col-12 col-lg-6 text-center">
                    <img className="text-center" src={Features20} style={{ maxWidth: '85%' }} alt="独自の天然成分技術" />
                  </div>
                  <div className="col-12 bg-white mt-5">
                    <h3 className="text-center my-3">除菌剤との比較</h3>
                    <div className="row">
                      <div className="col-12 col-lg-6 p-0 text-center">
                        <img className="p-3" src={Features21} style={{ maxWidth: '85%' }} alt="独自の天然成分技術" />
                        <p className="text-center text-muted">
                          <small>( 株 )食環境衛生研究所によるTERRA FORESTAの除菌実験結果</small>
                        </p>
                      </div>
                      <div className="col-12 col-lg-6 p-0 text-center">
                        <img className="p-3" src={Features22} style={{ maxWidth: '85%' }} alt="独自の天然成分技術" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="features_title">
                  タバコの消臭でお困りの方
                </div>
                <div className="row my-4 mr-0">
                  <div className="col-12 col-lg-6 features_text">
                    <p>
                      TERRA FORESTAなら、「森」の成分の消臭と香りによりタバコのイヤな臭いを除去致します。
                    </p>
                  </div>
                  <div className="col-12 col-lg-6 text-center">
                    <img className="p-3" src={Features30} style={{ width: '100%' }} alt="タバコの消臭でお困りの方" />
                  </div>
                </div>
                <div className="d-flex test-shop mb-4">
                  <div
                    className="d-flex align-items-center p-4 test-shop-left"
                    style={{
                      background: 'rgb(44,81,115)',
                    }}
                  >
                    <div
                      className="text-test-shop text-left p-4"
                      style={{
                        border: 'solid 2px white',
                        fontSize: '1.15rem',
                        fontWeight: 'bold',
                        color: 'white',
                      }}
                    >
                      TEST SHOP
                      <p
                        className="my-2"
                        style={{
                          color: 'rgb(237,226,71)',
                          fontSize: '1.5rem',
                        }}
                      >
                        まずは、
                        <br />
                        1カ月お試しをしたい方はこちら
                      </p>
                      荒れない肌を是非実感してください。
                    </div>
                  </div>
                  <div className="test-shop-center">
                    <img src={Features31} alt="商品特長" />
                  </div>
                  <div className="test-shop-right p-4 bg-white">
                    <h3 className="my-4">
                      TERRA FORESTA
                      <br />
                      ハンディ
                    </h3>
                    <p className="text-black my-4">
                      子供、アレルギーをお持ちの方に体に優しいノンアルコール天然成分です。
                    </p>
                    <Link
                      className="btn-test-shop d-block my-3"
                      to="/testshop"
                      style={{
                        color: 'white',
                        background: 'rgb(120,159,177)',
                        margin: 'auto',
                        height: '3rem',
                        width: '90%',
                        maxWidth: '300px',
                        borderRadius: '1.5rem',
                        textDecoration: 'none',
                        lineHeight: '3rem',
                        textAlign: 'center',
                      }}
                    >
                      お試しはこちら
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Features;
